import { useWindowSize } from "../../hooks/use-window-size";
import { Login } from "./login";
import { routeReporting } from "../../../front-office/navigation/preparation-route-props";
import { authenticationService } from "../../../services/authentication";
import { Message } from "../notifications/message";
import * as React from "react";
import { useMemo, useState } from "react";
import { ScanShipLoginComponent } from "../../../scan-and-ship/screen/login-screen/scan-ship-login";
import { LoginPageLayout } from "./login-page-layout";
import { RequestPasswordReset } from "../../../front-office/components/reset-password/request-password-reset";
import { useLocation, useNavigate } from "react-router-dom";

export interface ILoginWithCredentialsProps {
    isMobile: boolean;
    onChangeLoginMode: () => void;
}

enum LoginMode {
    Credentials,
    QrCode,
}

export const LoginPage = () => {
    const windowSize = useWindowSize();
    const [loginMode, setLoginMode] = useState(windowSize.isMobile && false ? LoginMode.QrCode : LoginMode.Credentials);

    return loginMode === LoginMode.Credentials ?
        <LoginPageWithCredentials isMobile={windowSize.isMobile}
                                  onChangeLoginMode={() => setLoginMode(LoginMode.QrCode)} /> :
        <ScanShipLoginComponent onChangeLoginMode={() => setLoginMode(LoginMode.Credentials)} />;
};

const LoginPageWithCredentials = (props: ILoginWithCredentialsProps) => {
    const [resetPasswordFormOpen, setResetPasswordFormOpen] = useState(false);
    const [resetPasswordUsername, setResetPasswordUsername] = useState("");

    const location = useLocation();
    const navigate = useNavigate();

    const handleForgotPasswordRequested = (userName?: string) => {
        setResetPasswordFormOpen(userName !== undefined);
        setResetPasswordUsername(userName ?? "");
    };

    const redirectAfterLoginPath = useMemo(() => !location.state || location.state.from === "" || location.state.from === "/login" ?
        props.isMobile ? "/scan-and-ship" : `/operations/${routeReporting}` :
        location.state.from, [location, props.isMobile]);

    const handleSuccess = () => {
        navigate(redirectAfterLoginPath, { replace: true });
    };

    return <LoginPageLayout>
        {!resetPasswordFormOpen ?
            <Login appName={props.isMobile ? "Scan & Ship" : "Click & Ship"}
                   enableQrLogin={props.isMobile}
                   onQrRequested={() => props.onChangeLoginMode()}
                   onForgotPasswordRequested={handleForgotPasswordRequested}
                   login={authenticationService.login}
                   onSuccess={handleSuccess} /> :
            <RequestPasswordReset userName={resetPasswordUsername} onCancel={() => handleForgotPasswordRequested(undefined)} />}
        <Message />
    </LoginPageLayout>;
};
